export enum ALERT_STATUS {
  PASS = 'PASS',
  FAIL = 'FAIL',
  SKIPPED = 'SKIPPED',
  ERROR = 'ERROR'
}
